const formataValor = (value: string): string =>
  Intl.NumberFormat('pt-BR').format(
    parseFloat(value),
  );

export default formataValor;